'use client';

import React, { useState } from 'react';
import ProductModelSwitcher from "./ProductModelSwitcher/ProductModelSwitcher";
import ModelComparison from "./ModelComparison/ModelComparison";

export default function ClientProductView({ variantsData, initialVariantId }) {
  const [activeVariantId, setActiveVariantId] = useState(
    initialVariantId || (variantsData.length > 0 ? variantsData[0].id : null)
  );

  return (
    <>
      <ProductModelSwitcher
        variants={variantsData}
        activeVariantId={activeVariantId}
        onVariantChange={setActiveVariantId}
      />
      {variantsData && variantsData.length > 1 && (
        <div className="bg-white pt-10 pb-24 relative z-20">
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">مقایسه مدل‌ها</h2>
          </div>
          <ModelComparison
            variants={variantsData}
            activeVariantId={activeVariantId}
          />
        </div>
      )}
    </>
  );
}
